//Obtener datos del footer
export function getFooterDataApi() {
    const url = `${process.env.REACT_APP_BACKEND_URL}/api/footer`;
    const params = {
        method: "GET",
        headers: {
            "Content-Type": "application/json"
        },
    };

    return fetch(url, params)
        .then(response => {
            return response.json()
                .then(result => {
                    return result;
                })
                .catch(err => {
                    return err.message;
                })
        })
}

//Actualiza los datos de la usuario
export function updateFooterDataApi(token, data, id) {
    const url = `${process.env.REACT_APP_BACKEND_URL}/api/footer/${id}`;

    const params = {
        method: "PUT",
        headers: {
            "Content-Type": "application/json",
            "x-auth-token": token
        },
        body: JSON.stringify(data)
    }
    return fetch(url, params).then(response => {
            return response.json();
        })
        .then(result => {
            if (result.footer) {
                return { ok: true, result, message: result.msg };
            }
            return { ok: false, message: result.msg };
        })
        .catch(err => {
            return { ok: false, message: err.msg };
        });

}